<ng-container *ngIf="menuItems$ | async as items">
  <app-menu [menuItems]="items"></app-menu>
</ng-container>
